<template>
  <div>
    LAT1: <input type="text" v-model="lat1"><span style="margin-right: 10px"></span>LON1: <input type="text" v-model="lon1"><br>
    LAT2: <input type="text" v-model="lat2"><span style="margin-right: 10px"></span>LON2: <input type="text" v-model="lon2"><br>
  
    <br><br>
    <b>DISTANCE</b>: {{ distance().toFixed(2) }} meters <span v-if="distance() > 1000">( {{ (distance() / 1000).toFixed(3) }} kilometers )</span><br><br>
    <b>POINT1</b>: {{ lat1 }}, {{ lon1 }}<br><br>
    <div v-for="zoom in zooms">
      <b>Zoom {{ zoom }}</b> Z/X/Y: {{ zoom }}/{{ lon2tile(Number(lon1), Number(zoom)) }}/{{ lat2tile(Number(lat1), Number(zoom)) }}
    </div>  
  
    <br><br>
    <b>POINT2</b>: {{ lat2 }}, {{ lon2 }}<br><br>
    <div v-for="zoom in zooms">
      <b>Zoom {{ zoom }}</b> Z/X/Y: {{ zoom }}/{{ lon2tile(Number(lon2), Number(zoom)) }}/{{ lat2tile(Number(lat2), Number(zoom)) }}
    </div>
  
    <br><br>
    <b>POINT1 POINT2</b>: rectangle tile count<br><br>
    <div v-for="zoom in zooms">
      <b>Zoom {{ zoom }}</b>: X = [{{ tilecount(Number(lat1), Number(lon1), Number(lat2), Number(lon2), Number(zoom))[0] }}-{{ tilecount(Number(lat1), Number(lon1), Number(lat2), Number(lon2), Number(zoom))[1] }}], Y = [{{ tilecount(Number(lat1), Number(lon1), Number(lat2), Number(lon2), Number(zoom))[2] }}-{{ tilecount(Number(lat1), Number(lon1), Number(lat2), Number(lon2), Number(zoom))[3] }}]: <b>{{ tilecount(Number(lat1), Number(lon1), Number(lat2), Number(lon2), Number(zoom))[4] }}</b>
    </div>
    <br><br>
    <div v-if="geoportal_activated">
      <h2>Geoportal rzeźba terenu</h2>
      <div id="map" style="width: 200px; height: 200px"></div>
      ZOOM from: <input type="text" v-model="geoportal_zoom_from"><span style="margin-right: 10px"></span>ZOOM to: <input type="text" v-model="geoportal_zoom_to"><br>
      <button :disabled="generatingGeoportal" @click="generate_geoportal">Generate</button><br></br>
    </div>
    <button v-else @click="activateGeoportal">Activate geoportal</button>
  </div>
</template>
    
<script lang="ts">
import { distanceBetweenPoints } from '@/ts/utils/coords';
import { Util } from 'leaflet';
import BaseComponent from '@/components/Base.vue';
import { defineComponent } from "vue";
import L from 'leaflet';

export default defineComponent({
    extends: BaseComponent,
    data() {
        return {
            lat1: 51.5,
            lon1: 18.5,
            lat2: 51.5,
            lon2: 18.5,
            zooms: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
            geoportal_zoom_from: 1,
            geoportal_zoom_to: 15,
            generatingGeoportal: false,
            geoportal_activated: false,
            layer: null as L.TileLayer.WMS,
            urls: [] as {'x': number, 'y': number, 'z': number, 'filename': string, 'url': string}[],
        };
    },
    methods: {
      activateGeoportal() {
        this.geoportal_activated = true;
        this.$nextTick(() => {
          const map = L.map('map', {contextmenu: false, contextmenuItems: []});
          map.setView([this.lat1, this.lon1], 11);
          this.layer = new L.TileLayer.WMS('https://mapy.geoportal.gov.pl/wss/service/PZGIK/NMT/GRID1/WMS/ShadedRelief?', {
            layers: 'Raster',
            layerName: 'Raster',
          });
          this.layer.addTo(map);
        });
      },
        lon2tile(lon: number, zoom: number) {
            return Math.floor((lon+180)/360*Math.pow(2,zoom))
        },
        distance() {
            return distanceBetweenPoints(Number(this.lat1), Number(this.lon1), Number(this.lat2), Number(this.lon2))
        },
        lat2tile(lat: number, zoom: number) {
            return Math.floor((1-Math.log(Math.tan(lat*Math.PI/180) + 1/Math.cos(lat*Math.PI/180))/Math.PI)/2 *Math.pow(2,zoom))
        },
        tilecount(lat1: number, lon1: number, lat2: number, lon2: number, zoom: number) {
            const y1 = this.lat2tile(lat1, zoom);
            const y2 = this.lat2tile(lat2, zoom);
            const x1 = this.lon2tile(lon1, zoom);
            const x2 = this.lon2tile(lon2, zoom);
            let ydiff = 0;
            if (y1 >= y2) {
              ydiff = y1 - y2;
            } else {
              ydiff = y2 - y1;
            }
            let xdiff = 0;
            if (x1 >= x2) {
              xdiff = x1 - x2;
            } else {
              xdiff = x2 - x1;
            }
            return [Math.min(x1, x2), Math.max(x1, x2), Math.min(y1, y2), Math.max(y1,y2), (xdiff + 1) * (ydiff + 1)];
        },
        formatedTimestamp() {
            const d = new Date();
            const date = d.toISOString().split('T')[0];
            const time = d.toTimeString().split(' ')[0].replaceAll(":", "-");
            return `${date}_${time}`
        },
        generate_geoportal() {
            // @ts-ignore
            this.layer.getTileDetailsUrls = function (coords) {
              const tmp = {x: coords.x, y: coords.y, z: coords.z};
              
              // @ts-ignore
              let tileBounds = this._tileCoordsToNwSe(coords)
              // @ts-ignore
              let crs = this._crs
              let boundsTmp = new L.Bounds(crs.project(tileBounds[0]), crs.project(tileBounds[1]))
              let min = boundsTmp.min
              let max = boundsTmp.max
              // @ts-ignore
              let bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ?
                  [min.y, min.x, max.y, max.x] :
                  [min.x, min.y, max.x, max.y]).join(',')
              let url = L.TileLayer.prototype.getTileUrl.call(this, coords);
              // @ts-ignore
              tmp.box = bbox;
              const retVal = url + Util.getParamString(this.wmsParams, url, this.options.uppercase) + (this.options.uppercase ? '&BBOX=' : '&bbox=') + bbox;
              // @ts-ignore
              tmp.url = retVal;
              return tmp;
            },

            this.generatingGeoportal = true;
            setTimeout(() => {
              this.urls = [];
              for(let zoom = Number(this.geoportal_zoom_from); zoom <= Number(this.geoportal_zoom_to); zoom++) {
                const bounds = this.tilecount(Number(this.lat1), Number(this.lon1), Number(this.lat2), Number(this.lon2), zoom);
                let x = bounds[0];
                while(x <= bounds[1]) {
                  let y = bounds[2];
                  while(y <= bounds[3]) {
                    const point = new L.Point(x, y);
                    // @ts-ignore
                    point.z = zoom;
                    // @ts-ignore
                    const url = this.layer.getTileDetailsUrls(point)['url'];
                    const filename = zoom + '/' + x + '/' + y + '.jpg';
                    this.urls.push({z: zoom, x: x, y: y, url: url, filename: filename});
                    y = y + 1;
                  }
                  x = x + 1;
                }
              }
              this.saveFile(JSON.stringify(this.urls), "geoportal_" + this.formatedTimestamp() + ".json");
              this.formatedTimestamp();
              this.generatingGeoportal = false;
            }, 100);
        }
    }
})

</script>